<template>
  <cus-order-dialog>
    <template v-slot:title>
      <div v-if="!is_detail" class="order-button">
        <cus-button
          :text="is_invalid ? '未接訂單' : '失效訂單'"
          color="blue"
          style="min-height: 45px"
          @click="is_invalid = !is_invalid"
        ></cus-button>
      </div>
      <p v-if="!is_detail" class="dialog-title">內部平台{{ is_invalid ? '：失效訂單' : '' }}</p>
      <p v-else class="dialog-title">內部平台{{ is_invalid ? '：失效訂單 - 查看訂單' : '：查看訂單' }}</p>
      <div v-if="!is_detail" class="source-radio">
        <cus-radio :radioList="sourceBtns" v-model:selectValue="selectSource"></cus-radio>
      </div>
    </template>
    <template v-slot:body>
      <div class="body-wrap">
        <!--  訂單列表 -->
        <div v-if="!is_detail" class="order-list">
          <!-- 未接訂單bar -->
          <div v-if="!is_invalid" class="type-unprocessed">
            <p>未接({{ orderList?.length }})</p>
          </div>
          <!-- 失效訂單bar -->
          <div v-else class="type-invalid">
            <p :class="invalidStatus === 24 ? 'select' : ''" @click="invalidStatus = 24">
              門市拒單({{ getInvalidCount(24) }})
            </p>
            <p :class="invalidStatus === 2 ? 'select' : ''" @click="invalidStatus = 2">
              客人取消({{ getInvalidCount(2) }})
            </p>
          </div>
          <order-list
            type="incoming"
            :orderList="orderList"
            v-model:selectOrder="selectOrder"
            v-model:listPage="listPage"
          ></order-list>
        </div>
        <!--  查看訂單 -->
        <div v-else class="order-detail">
          <all-detail-info :orderData="orderData"></all-detail-info>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <div v-if="!is_detail" class="d-flex" :style="`width: ${is_invalid ? '100%' : '50%'}`">
          <cus-button text="關閉" color="white" :width="50" @click="close"></cus-button>
          <cus-button
            text="查看訂單"
            :color="is_invalid ? 'blue' : 'white'"
            :width="50"
            :disabled="!selectOrder"
            @click="handleClickDetail"
          ></cus-button>
        </div>
        <cus-button v-else text="返回" color="white" :width="is_invalid ? 100 : 50" @click="backToList"></cus-button>
        <cus-button
          v-if="!is_invalid"
          text="拒單"
          color="white"
          :width="25"
          :disabled="!selectOrder"
          @click="openHeaderDialog('reject')"
        ></cus-button>
        <cus-button
          v-if="!is_invalid"
          text="接單"
          color="blue"
          :width="25"
          :disabled="!selectOrder"
          @click="handleAcceptOrder"
        ></cus-button>
      </div>
    </template>
  </cus-order-dialog>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { ref, inject, defineAsyncComponent, watch } from 'vue';
import { getIncomingSourceButtons } from '@/utils/define';
import { useGetters, useActions } from '@/utils/mapStore';
import { useDialog } from '@/utils/dialog';
export default {
  name: 'incoming-order',
  components: {
    OrderList: defineAsyncComponent(() => import('@/components/orderDialog/OrderList.vue')),
    AllDetailInfo: defineAsyncComponent(() => import('@/components/orderDialog/AllDetailInfo.vue')),
    RejectOrder: defineAsyncComponent(() => import('@/components/orderDialog/RejectOrder.vue')),
  },
  setup() {
    //接受provide參數
    const close = inject('order_close');
    const controlCloseButton = inject('order_controlCloseButton');
    //取得radio button清單
    const sourceBtns = getIncomingSourceButtons();
    const selectSource = ref(sourceBtns[0].value);
    //設定列表參數
    const is_invalid = ref(false);
    const selectOrder = ref(null);
    const listPage = ref(1);
    const getPageItem = useGetters('handleOrder', ['getPageItem']);
    //取得訂單列表
    const { doGetValidIncomingOrderList, doGetInvalidIncomingOrderList } = useActions('handleOrder', [
      'doGetValidIncomingOrderList',
      'doGetInvalidIncomingOrderList',
    ]);
    const { getValidIncomingOrder, getInvalidIncomingOrder } = useGetters('handleOrder', [
      'getValidIncomingOrder',
      'getInvalidIncomingOrder',
    ]);
    const orderList = ref([]);
    const getOrderList = async (source) => {
      selectOrder.value = null;
      //未接訂單
      if (!is_invalid.value) {
        if (source === 'all') {
          orderList.value = getValidIncomingOrder.value;
        } else {
          orderList.value = [];
          getValidIncomingOrder.value.forEach((e) => {
            if (e.source === source) orderList.value.push(e);
          });
        }
        //失效訂單
      } else {
        if (source === 'all') {
          orderList.value = [];
          getInvalidIncomingOrder.value.forEach((e) => {
            if (e.status === invalidStatus.value) orderList.value.push(e);
          });
        } else {
          orderList.value = [];
          getInvalidIncomingOrder.value.forEach((e) => {
            if (e.source === source && e.status === invalidStatus.value) orderList.value.push(e);
          });
        }
      }
    };
    //未接/失效切換
    watch(is_invalid, async () => {
      if (!is_invalid.value) await doGetValidIncomingOrderList();
      else await doGetInvalidIncomingOrderList();
      selectSource.value = sourceBtns[0].value;
      getOrderList(selectSource.value);
      listPage.value = 1;
    });
    //監聽清單
    watch(getValidIncomingOrder, () => {
      getOrderList(selectSource.value);
    });
    //來源切換
    watch(
      selectSource,
      async () => {
        if (selectSource.value === 'all') {
          if (!is_invalid.value) await doGetValidIncomingOrderList();
          else await doGetInvalidIncomingOrderList();
        }
        getOrderList(selectSource.value);
        listPage.value = 1;
      },
      { immediate: true }
    );
    //失效訂單原因切換
    const invalidStatus = ref(24); //status:24-門市拒單 / status:2-客人取消
    watch(invalidStatus, () => {
      getOrderList(selectSource.value);
      listPage.value = 1;
    });
    //取得失效訂單比數
    const getInvalidCount = (status) => {
      const newArr = getInvalidIncomingOrder.value.filter((e) => e.status === status);
      return newArr.length;
    };

    //查看訂單
    const orderData = ref(null);
    const is_detail = ref(false);
    watch(is_detail, () => {
      controlCloseButton(is_detail.value);
    });
    const doGetOrderInfo = useActions('handleOrder', ['doGetOrderInfo']);
    const handleClickDetail = async () => {
      const res = await doGetOrderInfo(selectOrder.value.order_id);
      orderData.value = res;
      is_detail.value = true;
    };
    //返回列表
    const backToList = () => {
      is_detail.value = false;
      orderData.value = null;
    };

    //接單
    const doAcceptOrder = useActions('handleOrder', ['doAcceptOrder']);
    const handleAcceptOrder = async () => {
      await doAcceptOrder({ order_id: selectOrder.value.order_id, source: 'inner' });
      backToList();
      selectOrder.value = null;
      if (listPage.value > (Math.ceil(orderList.value.length / getPageItem.value) || 1)) {
        listPage.value = Math.ceil(orderList.value.length / getPageItem.value) || 1;
      }
    };

    //開啟彈窗
    const { dialogTemplate, openHeaderDialog, closeDialog } = useDialog();

    //拒單
    const doRejectOrder = useActions('handleOrder', ['doRejectOrder']);
    const handleRejectOrder = async (val) => {
      const data = {
        order_id: selectOrder.value.order_id,
        note: val.input_reason ? val.input_reason : val.select_reason,
      };
      await doRejectOrder(data);
      closeDialog();
      backToList();
      selectOrder.value = null;
    };
    return {
      close,
      sourceBtns,
      selectSource,
      selectOrder,
      listPage,
      orderList,
      is_invalid,
      invalidStatus,
      getInvalidCount,
      orderData,
      is_detail,
      handleClickDetail,
      backToList,
      handleAcceptOrder,
      dialogTemplate,
      openHeaderDialog,
      handleRejectOrder,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
.order-button {
  width: 140px;
  position: absolute;
  top: 16px;
  left: 16px;
}
.source-radio {
  width: 250px;
  position: absolute;
  top: 46px;
  right: 80px;
  transform: translateY(-50%);
}
$bar-height: 6vh;
.body-wrap {
  position: relative;
  padding: 0 4px;
}
.order-list {
  height: 100%;
  padding: 20px 0 0;
  display: grid;
  grid-template-rows: $bar-height auto;
  grid-gap: 8px;
  .type-unprocessed {
    width: 100%;
    background-color: $color-blue;
    border-radius: 27px;
    text-align: center;
    font-size: 2.2rem;
    color: #fff;
    line-height: $bar-height;
  }
  .type-invalid {
    width: 100%;
    background-color: $color-gray-6;
    border-radius: 27px;
    text-align: center;
    font-size: 2.2rem;
    color: $color-blue;
    display: grid;
    grid-template-columns: 50% 50%;
    p {
      line-height: $bar-height;
      transition: 0.2s;
      border-radius: 27px;
      cursor: pointer;
    }
    p.select {
      background-color: $color-blue;
      color: #fff;
    }
  }
}
.order-detail {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
